export default function Header(props) {

		return (
			<div className='s1-header col-xs-12 row'>
				{props.data.title}
			</div>
		);
	}



// WEBPACK FOOTER //
// ./components/contentTypes/header/header.js